import { DRAG_THRESHOLD_PX } from "./booking_drag_and_drop_manager.constants";
import { PointerDownData } from "./booking_drag_and_drop_manager.types";

// What to do with the dragging after a pointer move: start it, move the booking, cancel it or ignore the move
export enum PointerMoveAction {
  Ignore = "ignore",
  Start = "start",
  Move = "move",
  Cancel = "cancel"
}

export const hasMovedBeyondDragThreshold = (
  { originX, originY }: Pick<PointerDownData, "originX" | "originY">,
  { clientX, clientY }: Pick<PointerEvent, "clientX" | "clientY">
): boolean =>
  Math.abs(clientX - originX) >= DRAG_THRESHOLD_PX || Math.abs(clientY - originY) >= DRAG_THRESHOLD_PX;

type GetPointerMoveAction = {
  pointerDownData: PointerDownData | null;
  isDragging: boolean;
  event: Pick<PointerEvent, "buttons" | "clientX" | "clientY">;
};

export const getPointerMoveAction = ({
  pointerDownData,
  isDragging,
  event
}: GetPointerMoveAction): PointerMoveAction => {
  if (!pointerDownData) {
    return PointerMoveAction.Ignore;
  }
  if (event.buttons === 0) {
    return PointerMoveAction.Cancel;
  }
  if (isDragging) {
    return PointerMoveAction.Move;
  }
  return hasMovedBeyondDragThreshold(pointerDownData, event)
    ? PointerMoveAction.Start
    : PointerMoveAction.Ignore;
};
